(() => {
  // The review-count link already contains the review count and Judge.me logo label.
  // Its repeated graphic is decorative; preserve any alt text supplied by the app.
  const mounted = new WeakSet()
  const attach = () => {
    const badges = document.querySelectorAll('a.jdgm-verified-count-badget')
    for (const badge of badges) {
      if (mounted.has(badge)) continue
      mounted.add(badge)
      const fix = () => {
        if (!badge.querySelector('.jdgm-verified-by__image img[alt="Judge.me Logo"]')) return
        for (const image of badge.querySelectorAll('.jdgm-verified-badge__image img:not([alt])')) image.alt = ''
      }
      fix()
      new MutationObserver(fix).observe(badge, { childList: true, subtree: true })
    }
    return badges.length > 0
  }
  if (attach()) return
  const observer = new MutationObserver(() => { if (attach()) observer.disconnect() })
  observer.observe(document.body, { childList: true, subtree: true })
  setTimeout(() => observer.disconnect(), 30000)
})()
